<template>
  <div class="centerPage payPage">
    <div class="centerPage_bigTitle">
      <img src="~images/logo.svg" alt="" />
      Create your team
    </div>

    <div class="centerPage_whiteBox whiteBox">
      <label>Team name</label>
      <input class="input" type="text" v-model="newRetroName" @keyup="newRetroNameChange" placeholder="" />
      <div v-if="errorMsg !== ''" class="error-msg">
        {{ errorMsg }}
      </div>
      <button v-on:click="createTeam" :disabled="loading" v-bind:class="[loading ? 'loading' : '', 'button']">Create team</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import firebase from 'firebase';
import _get from 'lodash.get';
import db, { ANALYTICS } from '../../firebase-config';
import mixins from 'src/mixins.js';

export default {
  components: {},
  mixins: [mixins],
  data() {
    return {
      elements: null,
      newRetroName: '',
      sources: {},
      loading: false,
      errorMsg: ''
    };
  },
  computed: {
    ...mapState(['currentUser', 'userInfo', 'userInfoLoaded'])
  },
  methods: {
    newRetroNameChange: function () {
      this.errorMsg = '';
    },
    createTeam: async function () {
      if (!this.newRetroName) return (this.errorMsg = "Team name can't be empty");

      this.loading = true;
      if (!this.userInfoLoaded) return;

      const generateAvailableWorkspaceId = async () => {
        const newWorkspaceIdLocal = Math.random().toString(36).substring(2, 6);
        const doc = await firebase.firestore().collection('workspaces').doc(newWorkspaceIdLocal).get()
        if (doc.exists) {
          return await generateAvailableWorkspaceId();
        } else {
          return newWorkspaceIdLocal;
        }
      };

      const newWorkspaceId =  await generateAvailableWorkspaceId();
      await firebase.firestore().collection('workspaces').doc(newWorkspaceId).set({
        name: this.newRetroName,
      })

      await firebase.firestore().collection('workspaces').doc(newWorkspaceId).update({
        admins: [this.currentUser.uid],
        payer: this.currentUser.uid,
        users: [],
        invites: [],
        'billing.subscriptionStatus':'Paid'
      })

      await firebase.firestore().collection('usersInfo').doc(this.currentUser.uid).update({
        adminWorkspaces: firebase.firestore.FieldValue.arrayUnion(newWorkspaceId),
        allWorkspaces: firebase.firestore.FieldValue.arrayUnion(newWorkspaceId),
      })

      const userListener = firebase.firestore().collection('usersInfo').doc(`${this.currentUser.uid}`)
        .onSnapshot((snapshot) => {
          if (_get(snapshot.data(),'allWorkspaces.length',0) > 0) {
            this.loading = false;
            userListener();
            this.$router.push('/dashboard');
          }
        });
    },
    // userInfoCheck: function () {
    //   if (!this.userInfoLoaded) return;
      // if (this.allWorkspaces.length !== 0) {
      //   this.$router.push('/dashboard');
      // }
    // }
  },
  mounted() {
    ANALYTICS.logEvent('page_view');
  }
};
</script>
